// The Index Composer's data source for MASTER values: catalog Index Sheets (UtlCfg_Index_Sheet)
// and their master datasheet values (UtlCfg_DSValues), against the library boxes of each sheet's
// current master revision. Same ten methods as projectSource in IndexComposer.js, each returning
// an axios-shaped { data } so the composer reads it unchanged.
//
// The catalog has no project behind it, so there are no tags and no related project rows: those
// methods answer empty and field-bound boxes print blank, as they do for a sheet with no tag.
import { dsComposerApi, dsMasterCatalogApi, appCfgApi } from '../../services/api';
import { toComposerInstrument } from './masterCatalog';

const empty = data => Promise.resolve({ data });

export const MASTER_DATABASE = { id: 'master', databaseName: '', displayName: 'Master catalog' };

export const masterSource = {
  getDatabases:     ()                    => empty([MASTER_DATABASE]),
  getFieldMetadata: (table)               => appCfgApi.getFieldMetadata(table),
  getRelatedRow:    ()                    => empty(null),
  getInstruments:   ()                    => dsMasterCatalogApi.getSheets()
    .then(res => ({ ...res, data: (res.data ?? []).map(toComposerInstrument) })),
  getLayoutSpec:    ()                    => dsComposerApi.getTemplates(),
  getLines:         (dsConfigId)          => dsComposerApi.getComposerLines(dsConfigId),
  getValues:        (sheetId)             => dsMasterCatalogApi.getValues(sheetId),
  getTags:          ()                    => empty([]),
  updateValue:      (id, payload, config) => dsMasterCatalogApi.updateValue(id, payload, config),
  createValue:      (payload, config)     => dsMasterCatalogApi.createValue(payload.Index_Sheet, payload, config),
};
